// extracted by mini-css-extract-plugin
module.exports =  {"styledSyntaxHighlighter":"CustomCode-module__styledSyntaxHighlighter--Tds9B"};